import { ComputeStrategy } from "components/workflow-template-editor/model";

type UUID = string;

export interface IUser {
  user_id: UUID;
  first_name: string;
  last_name: string;
  email: string;
}

export interface IOffset {
  id: string;
  name: string;
  value: number;
  order: number;
  is_editable: boolean;
}

export enum EstimateStatus {
  PENDING = "PENDING",
  SUBMITTED = "SUBMITTED"
}

export interface IMaterial {
  id: UUID;
  material_id: number;
  name: string;
  invite_id?: UUID;
  spec_section_no: string | null;
  spec_section_name: string | null;
  material_tag: string | null;
  description: string | null;
  estimate_status: EstimateStatus;
  offsets: IOffset[];
  estimate_invite_feature_id: UUID;
  updated_at: string | null;
  request_type?: "OFFSET" | "MILESTONE";
  dateblock_compute_strategy?: ComputeStrategy | number | string;
  ready_for_release?: boolean;
  workflow_status?: string;
  comment?: string | null;
  milestones?: IMaterialMilestone[];
  required_on_site_date?: string | null;
  current_expected_on_site?: string | null;
  material_status?: string | null;
  material_status_date?: string | null;
  last_milestone_slippage?: number | null;
}

export interface IMaterialMilestone {
  id: UUID;
  order: number;
  projected_date?: string | null;
  committed_date?: string | null;
  actual_date: string | null;
  planned_date: string | null;
  name: string;
}

/** Submit payload milestone: same fields as API, with projected_date or committed_date. */
export type UpdateLeadTimeRequestMilestone = Omit<
  IMaterialMilestone,
  "projected_date"
> & {
  projected_date?: string | null;
  committed_date?: string | null;
};

export interface RequsetLeadTimeData {
  project_name: string;
  gc_company: string;
  materials: IMaterial[];
  project_id: UUID;
  assignee_first_name: string;
  assignee_last_name: string;
  assignee_vendor_name: string;
  assignee_organization_name: string;
  assignee_email: string;
  gc_first_name: string;
  gc_last_name: string;
  gc_organization_name: string;
  gc_email: string;
  notes: string;
  timezone_id: string;
  token: string;
  created_on: string;
}

export interface UpdateLeadTimeRequestItem {
  estimate_invite_feature_id: UUID;
  feature_instance_id: UUID;
  comment?: string | null;
  offsets?: {
    id: string;
    value: number;
  }[];
  milestones?: UpdateLeadTimeRequestMilestone[];
}

export type UpdateLeadTimeRequestData = UpdateLeadTimeRequestItem[];
